import React from 'react';
import {YMaps} from 'react-yandex-maps';

/**
 * Общая обёртка над YMaps с ключом API из окружения.
 *
 * Ключ задаётся переменной `REACT_APP_YANDEX_MAPS_API_KEY` в `.env.local`.
 * Без ключа карта продолжает работать в ограниченном режиме, поэтому dev-окружение
 * не ломается, но для production ключ обязателен.
 */

export const yandexMapsApiKey = process.env.REACT_APP_YANDEX_MAPS_API_KEY || '';

export const hasYandexMapsApiKey = Boolean(yandexMapsApiKey);

function YandexMapsProvider({children}) {
  const query = yandexMapsApiKey ? {apikey: yandexMapsApiKey} : {};
  return <YMaps query={query}>{children}</YMaps>;
}

export default YandexMapsProvider;
